<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Detail Promo</h5>
            </template>
            <div class="detail-data-wrapper mb-4">
                <h6 class="form-title">DATA PROMO</h6>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Nama Promo</b-col>
                    <b-col>{{ promo.title }}</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Link</b-col>
                    <b-col v-if="promo.link != null"><a :href="'https://' + promo.link" >{{ promo.link }}</a></b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Periode</b-col>
                    <b-col v-if="promo.startDate != null && promo.endDate != null">{{ this.$helper.formatTanggalDMY(promo.startDate) + " sampai " + this.$helper.formatTanggalDMY(promo.endDate) }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Foto Promo</b-col>
                    <b-col v-if="$helper.isNotNullAndNotEmpty(promo.pathImage)">
                        <a v-bind:href="$baseFilePath + promo.pathImage" target="_blank">
                            <img width="150px" :src="$baseFilePath + promo.pathImage" alt="Foto Pendukung 3">
                        </a>
                    </b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Token</b-col>
                    <b-col v-if="promo.tokenHeader != null">{{ promo.tokenHeader }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
                <b-row class="mb-2">
                    <b-col cols="4" class="detail-data-label">Is Active</b-col>
                    <b-col v-if="promo.isActive != null">{{ promo.isActive }}</b-col>
                    <b-col v-else>-</b-col>
                </b-row>
            </div>
            <div class="detail-edit-btn">
                <b-button variant="pgiBtn" name="promoEditBtn" @click="editPromo">Edit</b-button>
            </div>
        </b-card>
    </div>
</template>

<script>
export default {
    name: 'detail-promo',
    data(){
        return{
            id: null,
            initStatus: 0,
            promo: null
        }
    }, 
    methods:{

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id

            let getSinglePromo = this.$axios.get('/promo-mobile/' + this.id).then(response => {
                this.promo = response.data

                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getSinglePromo]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },


        //----------------- Fungsi Lain -----------------

        toggleBusy() {
            if(this.isBusy == true) this.isBusy = false
            else this.isBusy = true
        },
        editPromo(){
            this.$router.push({
                path: `${this.$route.path}/edit`
            })
        }
    },

    created(){
        this.init()
    }
}
</script>
